import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';

import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'ui-camera-photo',
  templateUrl: './camera-photo.component.html',
  styleUrls: [
    './camera-photo.component.scss'
  ]
})
export class CameraPhotoComponent implements OnInit {

  title: string = '';
  messages: string[] = [];
  cancelText: string = 'Cancel';
  confirmText: string = 'Confirm';
  confirmColor: string = 'confirm';

  onClose: Subject<any> = new Subject();

  showWebcam = true;
  isCameraExist = true;

  errors: WebcamInitError[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  mediaDevices: MediaDeviceInfo[] = []
  currentDevice: string | null = null;

  webcamImage: WebcamImage | null = null;

  height: number = window.innerHeight; // 720
  width: number = window.innerWidth; // 1200

  showGrid: boolean = false;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.onClose = new Subject();

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.mediaDevices = mediaDevices;
        this.isCameraExist = mediaDevices && mediaDevices.length > 0;
      });
  }

  dismiss(data?: any) {
    this.modalController.dismiss(data);
  }

  takeSnapshot(event: any): void {
    event.preventDefault();
    this.trigger.next();
  }

  onOffWebCam(event: any) {
    event.preventDefault();
    this.showWebcam = !this.showWebcam;
    this.webcamImage = null
  }

  onWebCam(event: any) {
    event.preventDefault();
    this.showWebcam = true;
    this.webcamImage = null
  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error);
    if (error.mediaStreamError && error.mediaStreamError.name === "NotAllowedError") {
      console.warn("Camera access was not allowed by user!");
    }
  }

  changeWebcam(directionOrDeviceId: boolean | string) {
    this.nextWebcam.next(directionOrDeviceId);
  }

  handleImage(webcamImage: WebcamImage) {
    // this.getPicture.emit(webcamImage);
    this.webcamImage = webcamImage;
    this.showWebcam = false;
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  cameraWasSwitched(deviceId: string): void {
    // console.log('active device: ' + deviceId);
    this.currentDevice = deviceId;
  }

  onChangeDevice(event: any) {
    // console.log('onChangeDevice', this.currentDevice);
    this.errors = [];
    this.changeWebcam(this.currentDevice || true);
  }

  _toggleGrid() {
    this.showGrid = !this.showGrid;
  }
}
